import { render } from "./dcOwner.vue?vue&type=template&id=7821eda2&scoped=true"
import script from "./dcOwner.vue?vue&type=script&lang=js"
export * from "./dcOwner.vue?vue&type=script&lang=js"

import "./dcOwner.vue?vue&type=style&index=0&id=7821eda2&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/MODC/modc-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7821eda2"]])

export default __exports__